import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/date";
import GeneratingVideoPreview from "./GeneratingVideoPreview";

const statusStyles = {
  pending: "opacity-70",
  generating: "text-theme-primary",
  completed: "opacity-90",
  failed: "opacity-80",
};

const statusText = {
  pending: "Queued",
  generating: "Generating",
  completed: "Ready",
  failed: "Failed",
};

const VideoCard = ({ video, onOpen }) => {
  const title = video.idea_title || video.title || "Generated video";
  const status = video.status || "pending";
  const isGenerating = status === "pending" || status === "generating";
  const previewUrl = video.script_preview_url;

  return (
    <button
      type="button"
      onClick={() => onOpen(video.hash)}
      className="w-full text-left rounded-lg border border-theme-secondary bg-theme-secondary hover:bg-theme-main transition-colors p-4"
    >
      <div className="flex items-start gap-4">
        <div className="relative w-24 sm:w-28 flex-shrink-0 aspect-[9/16] rounded-lg overflow-hidden border border-theme-secondary bg-theme-main">
          {isGenerating ? (
            <GeneratingVideoPreview
              imageUrl={previewUrl}
              compact
              className="h-full w-full rounded-lg border-0"
            />
          ) : video.thumbnail_url ? (
            <img src={video.thumbnail_url} alt="" className="h-full w-full object-cover" />
          ) : previewUrl ? (
            <img src={previewUrl} alt="" className="h-full w-full object-cover" />
          ) : (
            <div className="h-full w-full flex items-center justify-center text-xs text-theme-text opacity-50 px-2 text-center">
              {status === "completed" ? "Video" : statusText[status] || "Video"}
            </div>
          )}
        </div>

        <div className="min-w-0 flex-1 space-y-2">
          <div className="flex items-start justify-between gap-3">
            <h3 className="text-base font-semibold text-theme-text truncate">{title}</h3>
            <span className={`text-xs font-medium ${statusStyles[status] || "opacity-70"}`}>
              {statusText[status] || status}
            </span>
          </div>

          <p className="text-xs text-theme-text opacity-70">
            {formatDate(video.create_date)}
          </p>

          {video.script_hash ? (
            <Link
              to={`/scripts/${encodeURIComponent(video.script_hash)}/`}
              onClick={(event) => event.stopPropagation()}
              className="inline-block text-xs text-theme-primary hover:underline"
            >
              View source script
            </Link>
          ) : null}

          {video.status_error ? (
            <p className="text-xs text-theme-text opacity-70 line-clamp-2">{video.status_error}</p>
          ) : null}
        </div>
      </div>
    </button>
  );
};

export default VideoCard;
